// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3034bdfe","732":"af546064","977":"15f16eb4"}[chunkId] + ".chunk.js";
};